import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";

const GroupField = ({ label, name, disabled = false, autoFocus = false, inputProps = {} }) => (
    <div className="ui-field">
        <Label>{label}</Label>
        <Input disabled={disabled} type="text" name={name} autoFocus={autoFocus} data-auto-focus={autoFocus ? "true" : null} {...inputProps}></Input>
        <FormFeedback className="col-12"></FormFeedback>
    </div>
);

const GroupFormFields = ({ disabled = false, autoFocusFirstField = false }) => (
    <section className="ui-section-block">
        <p className="ui-section-label">Datos del grupo</p>
        <div className="ui-row-2">
            <GroupField disabled={disabled} autoFocus={autoFocusFirstField} label={"Nombre"} name={"nombre"} />
            <GroupField disabled={disabled} label={"Abreviatura"} name={"abreviatura"} />
        </div>
        <div className="ui-row-2">
            <GroupField disabled={disabled} label={"Email"} name={"mail"} />
            <GroupField disabled={disabled} label={"Teléfono"} name={"telefono"} inputProps={validationInputProps.telefono} />
        </div>
    </section>
);

export default GroupFormFields;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/GroupFormFields.js